import type { PlayerTokenPayload } from "./types";

function base64UrlDecode(input: string): string {
  const base64 = input.replace(/-/g, "+").replace(/_/g, "/");
  const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
  return atob(padded);
}

/**
 * The X-Trim-Token value the API hands back from /api/auth/claim and
 * /api/auth/login is `<base64url(json)>.<hmac-sha256>` (server-side:
 * cookies.ts's signValue, player-token.ts's issuePlayerToken). It's signed,
 * not encrypted — the point of the signature is to stop a client from
 * FORGING a token, not from reading one it was already handed — so decoding
 * the payload here needs no secret. Used only to learn which org a
 * freshly-minted token belongs to (org.ts / storage.ts's org-keyed
 * localStorage), per the milestone spec's steer: prefer this over adding a
 * new org-context API endpoint.
 */
export function decodePlayerToken(token: string): PlayerTokenPayload | null {
  const dot = token.lastIndexOf(".");
  if (dot < 0) return null;
  try {
    const payload: unknown = JSON.parse(base64UrlDecode(token.slice(0, dot)));
    if (payload && typeof payload === "object") return payload as PlayerTokenPayload;
  } catch {
    /* tampered or malformed — treat as undecodable */
  }
  return null;
}
